"use client"

import { Switch as ChakraSwitch, useSlotRecipe } from "@chakra-ui/react"
import * as React from "react"

export interface SwitchProps extends ChakraSwitch.RootProps {
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>
  rootRef?: React.Ref<HTMLLabelElement>
  trackLabel?: { on: React.ReactNode; off: React.ReactNode }
  thumbLabel?: { on: React.ReactNode; off: React.ReactNode }
  compact?: boolean
}

export const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(function Switch(props, ref) {
  const { inputProps, children, rootRef, trackLabel, thumbLabel, compact, ...rest } = props

  const recipe = useSlotRecipe({ key: "switch" })
  const [recipeProps, localProps] = recipe.splitVariantProps({ ...rest, variant: (props.variant ?? compact ? "small" : undefined) })
  const styles = recipe(recipeProps)

  return (
    <ChakraSwitch.Root ref={rootRef} css={styles.root} {...localProps}>
      <ChakraSwitch.HiddenInput ref={ref} {...inputProps} />
      <ChakraSwitch.Control css={styles.control}>
        <ChakraSwitch.Thumb css={styles.thumb}>
          {thumbLabel && (
            <ChakraSwitch.ThumbIndicator fallback={thumbLabel?.off}>{thumbLabel?.on}</ChakraSwitch.ThumbIndicator>
          )}
        </ChakraSwitch.Thumb>
        {trackLabel && <ChakraSwitch.Indicator fallback={trackLabel.off}>{trackLabel.on}</ChakraSwitch.Indicator>}
      </ChakraSwitch.Control>
      {children != null && <ChakraSwitch.Label css={styles.label}>{children}</ChakraSwitch.Label>}
    </ChakraSwitch.Root>
  )
})
